import { useSearchParams } from 'react-router-dom';

export const STUDIO_MOBILE_FLOW = 'studio-mobile';

export const useFlow = () => {
  const [searchParams] = useSearchParams();

  return searchParams.get('flow');
};
